import ClipboardPlus from "./SVG/clipboard-plus.svg?react";

const ClipboardPlusIcon = () => {
  return <ClipboardPlus />;
};

export default ClipboardPlusIcon;
